import loadable from '@wix/yoshi-flow-editor/loadable'

export const FormEntry = loadable(
  () => import(/* webpackPrefetch: true, webpackChunkName: "form" */ '../router/form-entry/form-entry'),
)
